import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { useQuery } from "@apollo/client";
import preAuth from "../../gql/preAuth";
import { useTranslation } from "react-i18next";
import AppTable from "../../shared/AppTable";
import { Box } from "@mui/material";
import AppButton from "../../shared/AppButton";
import { MdArrowBack } from "react-icons/md";
import TableLoader from "../../common/TableLoader";
import ModernJsonReader from "../../shared/ModernJsonReader";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AdavcnePreAuthJsonViewModal({
  open,
  setOpen,
  handleClose,
  selectedItem,
}) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [item, setItem] = useState(null);
  const [showJsonView, setShowJsonView] = useState(false);
  const [jsonObject, setJsonObject] = useState(false);
  const [jsonDialogOpen, setJsonDialogOpen] = useState(false);

  const showJson = (item) => {
    setJsonObject(item);
    setShowJsonView(true);
    setJsonDialogOpen(true);
  };

  const onCloseShowJson = () => {
    setShowJsonView(false);
  };

  const { loading, error, data, refetch } = useQuery(
    preAuth.LIST_ADVANCE_PREAUTH_LOGS,
    {
      variables: {
        transactionId: selectedItem?.ID,
      },
      skip: !selectedItem?.ID,
      fetchPolicy: "network-only",
    },
  );

  useEffect(() => {
    if (data) {
      setItem(data?.listAdvancePreAuthLogs?.data || []);
    }
  }, [data]);

  const formatDate = (backendDateTime) => {
    // Create a new Date object using the backend datetime value
    const date = new Date(backendDateTime);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = String(date.getFullYear());
    return `${day}-${month}-${year}`;
  };

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });
    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToJson = (item) => {
    downloadFile({
      data: JSON.stringify(JSON.parse(item.log)),
      fileName: `${item.type}.json`,
      fileType: "text/json",
    });
  };
  const columns = [
    {
      header: t("SQ #"),
      render: (row, index) => index + 1,
    },
    {
      header: t("Transaction ID"),
      render: (row) => row?.transaction_id,
    },
    {
      header: t("Transaction Types"),
      render: (row) => row?.type,
    },
    {
      header: t("Date"),
      render: (row) => formatDate(row?.timestamp),
    },
  ];
  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={() => {
          jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
        }}
        TransitionComponent={Transition}
        style={{ background: "#0070C2", zIndex: 100 }}
      >
        <AppBar sx={{ position: "relative", paddingRight: 0 }}>
          <Toolbar className="" style={{ background: "#0070C2" }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
              }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {t("Advance Pre Authorization JSON View")}
            </Typography>
            <Button
              size="small"
              autoFocus
              color="inherit"
              onClick={() => {
                jsonDialogOpen ? setJsonDialogOpen(false) : handleClose();
              }}
            >
              {t("Close")}
            </Button>
          </Toolbar>
        </AppBar>
        {loading ? (
          <div className="mt-3">
            <TableLoader
              columns={4}
              rows={8}
              showHeaderButtons={false}
              showTitle={true}
              showPagination={false}
            />
          </div>
        ) : (
          <Box sx={{ p: 3 }}>
            {jsonDialogOpen ? (
              <div className="animate-fade-in">
                <div className="mb-2">
                  <AppButton
                    variant="outlined"
                    label={t("Back to List")}
                    onClick={() => setJsonDialogOpen(false)}
                    className="!text-primary !border-primary hover:bg-primary/50"
                    startIcon={
                      <MdArrowBack className={isRTL ? "rotate-180" : ""} />
                    }
                  />
                </div>
                {/* <ReactJsonTree data={jsonObject} /> */}
                <ModernJsonReader data={jsonObject} />
              </div>
            ) : (
              <AppTable
                columns={columns}
                data={item || []}
                onView={(row) => showJson(JSON.parse(row.log))}
                onDownload={(row) => exportToJson(row)}
              />
            )}
          </Box>
        )}
      </Dialog>
    </div>
  );
}
